import React from 'react'

import {
  SuccessFilled,
  Icon,
  Progress,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number } from 'prop-types'

function ProgressIcon() {
  return <SuccessFilled width="24" height="24" />
}

function CartProgressBar({
  shouldShowCartProgress,
  cartProgress,
}) {
  const progress = Math.floor(cartProgress)
  const isUnderThreshold = progress !== 100

  if (shouldShowCartProgress) {
    return (
      <span className="wayfinder__action-bottom-element">
        <span className="cart-progress">
          <Progress
            progress={progress}
            height={8}
            useGradient
            isSpaced={false}
            className="cart-progress__progress"
          />
        </span>
        <Icon
          notSpaced
          size="tiny"
          color="primary"
          disabled={isUnderThreshold}
          svgComponent={ProgressIcon}
          className={
            classnames('cart-progress__icon', isUnderThreshold && 'cart-progress__icon--disabled')
          }
        />
      </span>
    )
  }

  return null
}

CartProgressBar.propTypes = {
  shouldShowCartProgress: bool.isRequired,
  cartProgress: number.isRequired,
}

export default CartProgressBar
